<template>
  <div class="container__content">
    <div class="wrapper">
      <div class="content-7">
        <!-- 六合彩 用 headerDetail -->
        <header-detail v-if="lotteryType ==='hk6'" :lottery-code="lotteryCode" />
        <!-- 非六合彩 用 lotteryItem -->
        <lottery-item v-else :lottery-code="lotteryCode" @complete="reload" />
        <trend-tabbar @change-component="changeComponent" />

      </div>
      <div class="content-8">
        <transition name="tab" mode="out-in">
          <component
            :is="currentComponent"
            ref="KaiJiang"
            :lottery-type="lotteryType"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
// 綜合類
import JiShihKaiJiang from '@/components/web/pages/trend/JiShihKaiJiang/index'
import LiShihKaiJiang from '@/components/web/pages/trend/LiShihKaiJiang/index'
import HaoMaGuiLuTongJi from '@/components/web/pages/trend/HaoMaGuiLuTongJi/index'
import JinRiHaoMaTongJi from '@/components/web/pages/trend/JinRiHaoMaTongJi/index'
import LengReFenXi from '@/components/web/pages/trend/LengReFenXi/index'
import DanShuangDaxiaoLiShi from '@/components/web/pages/trend/DanShuangDaxiaoLiShi/index'
import LongHuTongJi from '@/components/web/pages/trend/LongHuTongJi/index'
import GuanYaHeLiangMianTongJi from '@/components/web/pages/trend/GuanYaHeLiangMianTongJi/index'
import LiShiHaoMaTongJi from '@/components/web/pages/trend/LiShiHaoMaTongJi/index'
import LiangMianTongJi from '@/components/web/pages/trend/LiangMianTongJi/index'
import MeiRihChangLongTongJi from '@/components/web/pages/trend/MeiRihChangLongTongJi/index'
import trendTabbar from '@/components/web/pages/trend/TrendTabbar'
import lotteryItem from '@/components/web/pages/trend/LotteryItem'

// 放 desktop 目錄下為了讓 postcss-pxtorem 排除 px 轉換 rem，影響 echarts 版面
// 六合彩 綜合類
import HeaderDetail from '@/components/desktop/pages/trend/HeaderDetail'
import KaiJiangHaoMa from '@/components/desktop/pages/trend/KaiJiangHaoMa'
import ReMenHaoMaTongJi from '@/components/desktop/pages/trend/ReMenHaoMaTongJi'
import YiLouHaoMaTongJi from '@/components/desktop/pages/trend/YiLouHaoMaTongJi'
import ReMenShengXiaoTongJi from '@/components/desktop/pages/trend/ReMenShengXiaoTongJi'
import YiLouShengXiaoTongJi from '@/components/desktop/pages/trend/YiLouShengXiaoTongJi'

// 六合彩 路珠類
import DanShuangLuJhu from '@/components/desktop/pages/trend/DanShuangLuJhu'
import DaXiaoLuJhu from '@/components/desktop/pages/trend/DaXiaoLuJhu'
import BoSeLuJhu from '@/components/desktop/pages/trend/BoSeLuJhu'
import ZongHeDanShuangLuZhu from '@/components/desktop/pages/trend/ZongHeDanShuangLuZhu'
import ZongHeDaXiaoLuZhu from '@/components/desktop/pages/trend/ZongHeDaXiaoLuZhu'
import WeiShuDaXiaoLuZhu from '@/components/desktop/pages/trend/WeiShuDaXiaoLuZhu'
import HeShuDanShuangLuZhu from '@/components/desktop/pages/trend/HeShuDanShuangLuZhu'

// 六合彩 走勢類
import ZhengMaZouShi from '@/components/desktop/pages/trend/ZhengMaZouShi'
import TeMaZouShi from '@/components/desktop/pages/trend/TeMaZouShi'
import ShengXiaoZouShi from '@/components/desktop/pages/trend/ShengXiaoZouShi'
import JiaQinYeShouZouShi from '@/components/desktop/pages/trend/JiaQinYeShouZouShi'
import NanNuShengXiaoZouShi from '@/components/desktop/pages/trend/NanNuShengXiaoZouShi'
import TianDiShengXiaoZouShi from '@/components/desktop/pages/trend/TianDiShengXiaoZouShi'
import SiJiShengXiaoZouShi from '@/components/desktop/pages/trend/SiJiShengXiaoZouShi'
import QinQiShuHuaZouShi from '@/components/desktop/pages/trend/QinQiShuHuaZouShi'
import SanSeShengXiaoZouShi from '@/components/desktop/pages/trend/SanSeShengXiaoZouShi'

// 路珠類
import LuJhuFenSi from '@/components/web/pages/trend/LuJhuFenSi/index'
import LongHuLuJhu from '@/components/web/pages/trend/LongHuLuJhu/index'
import DanShuangDaXiaoLuJhu from '@/components/web/pages/trend/DanShuangDaXiaoLuJhu/index'
import DongNanSiBeiLuJhu from '@/components/web/pages/trend/DongNanSiBeiLuJhu/index'
import GuanYaHeLuJhu from '@/components/web/pages/trend/GuanYaHeLuJhu/index'
import HaoMaChianHouLuJhu from '@/components/web/pages/trend/HaoMaChianHouLuJhu/index'
import ZongHeLuJhu from '@/components/web/pages/trend/ZongHeLuJhu/index'
import HaoMaLuJhu from '@/components/web/pages/trend/HaoMaLuJhu/index'
import PoSeLuJhu from '@/components/web/pages/trend/PoSeLuJhu/index'
import WeiShuDaXiaoLuJhu from '@/components/web/pages/trend/WeiShuDaXiaoLuJhu/index'
import HeShuDanShuangLuJhu from '@/components/web/pages/trend/HeShuDanShuangLuJhu/index'
import JhongFaBaiLuJhu from '@/components/web/pages/trend/JhongFaBaiLuJhu/index'

// 走勢類
// 定位走勢
import DingWeiZouShih from '@/components/web/pages/trend/DingWeiZouShih/index'
// 冠亞和走勢
import GuanYaHeZouShih from '@/components/web/pages/trend/GuanYaHeZouShih/index'
// 和值走勢
import HeJhihZouShih from '@/components/web/pages/trend/HeJhihZouShih/index'
// 大小走勢
import DaXiaoZouShih from '@/components/web/pages/trend/DaXiaoZouShih/index'
// 奇偶走勢
import JiOuZouShih from '@/components/web/pages/trend/JiOuZouShih/index'
// 龍虎走勢
import LongHuZouShih from '@/components/web/pages/trend/LongHuZouShih/index'
// 形態走勢
import XingTaiZouShih from '@/components/web/pages/trend/XingTaiZouShih/index'
// 基本走勢
import JiBenZouShih from '@/components/web/pages/trend/JiBenZouShih'
// 兩面橫版走勢
import LiangMianHengBanZouShih from '@/components/web/pages/trend/LiangMianHengBanZouShih'
// 號碼分佈
import HaoMaFenBu from '@/components/web/pages/trend/HaoMaFenBu'
// 定位橫版走勢
import DingWeiHengBanZouShih from '@/components/web/pages/trend/DingWeiHengBanZouShih'
// 和值橫版走勢
import HeJhihHengBanZouShih from '@/components/web/pages/trend/HeJhihHengBanZouShih'

export default {
  name: 'WebLotteryTrend',
  components: {
    trendTabbar,
    lotteryItem,

    JiShihKaiJiang,
    LiShihKaiJiang,
    HaoMaGuiLuTongJi,
    JinRiHaoMaTongJi,
    LengReFenXi,
    DanShuangDaxiaoLiShi,
    LongHuTongJi,
    GuanYaHeLiangMianTongJi,
    LiShiHaoMaTongJi,
    LiangMianTongJi,
    MeiRihChangLongTongJi,

    LuJhuFenSi,
    LongHuLuJhu,
    DanShuangDaXiaoLuJhu,
    GuanYaHeLuJhu,
    HaoMaChianHouLuJhu,
    ZongHeLuJhu,
    HaoMaLuJhu,
    PoSeLuJhu,
    WeiShuDaXiaoLuJhu,
    HeShuDanShuangLuJhu,
    JhongFaBaiLuJhu,
    DongNanSiBeiLuJhu,

    DingWeiZouShih,
    JiBenZouShih,
    GuanYaHeZouShih,
    DaXiaoZouShih,
    JiOuZouShih,
    LiangMianHengBanZouShih,
    HeJhihZouShih,
    HaoMaFenBu,
    LongHuZouShih,
    XingTaiZouShih,
    DingWeiHengBanZouShih,
    HeJhihHengBanZouShih,

    // 六合彩
    HeaderDetail,
    // 六合彩 綜合類
    KaiJiangHaoMa,
    ReMenHaoMaTongJi,
    YiLouHaoMaTongJi,
    ReMenShengXiaoTongJi,
    YiLouShengXiaoTongJi,

    // 六合彩 路珠類
    DanShuangLuJhu,
    DaXiaoLuJhu,
    BoSeLuJhu,
    ZongHeDanShuangLuZhu,
    ZongHeDaXiaoLuZhu,
    WeiShuDaXiaoLuZhu,
    HeShuDanShuangLuZhu,

    // 六合彩 走勢類
    ZhengMaZouShi,
    TeMaZouShi,
    ShengXiaoZouShi,
    JiaQinYeShouZouShi,
    NanNuShengXiaoZouShi,
    TianDiShengXiaoZouShi,
    SiJiShengXiaoZouShi,
    QinQiShuHuaZouShi,
    SanSeShengXiaoZouShi
  },
  async asyncData({ app, params }) {
    const { lottery_code } = params
    const lotteryType = await app.$getLotteryType(lottery_code)

    return { lotteryType }
  },
  data() {
    return {
      lotteryCode: this.$route.params.lottery_code,
      lotteryType: null,

      currentComponent: null
    }
  },
  mounted() {
    this.currentComponent = this.$route.query.trendType
  },
  methods: {
    changeComponent(componentName) {
      this.currentComponent = componentName
      this.$router.push(`/lottery/trend/${this.lotteryCode}?trendType=${componentName}`)
    },
    reload() {
      // 這個 function 用來重整開獎頁面的下方資料
      const { KaiJiang: midComponent } = this.$refs
      if (!midComponent) return
      const { name } = midComponent.$options
      // 透過 component name 判斷：如果中間層組件不是即時開獎或歷史開獎就不重整
      if (name !== 'JiShihKaiJiang' && name !== 'LiShihKaiJiang') return
      const { KaiJiangTable: kaiJiangComponent } = midComponent.$refs
      if (!kaiJiangComponent) return
      if (typeof kaiJiangComponent.getTableList !== 'function') {
        console.warn('走勢頁面：reload function沒有找到對應的子層function做呼叫, 無法執行 reload, ', kaiJiangComponent.getTableList)
        return
      }
      kaiJiangComponent.getTableList()
    }
  }
}
</script>

<style lang="scss">
//for 路珠 最新一期的珠子 一閃一閃
@keyframes fade {
  from {
    opacity: 1.0;
  }
  50% {
    opacity: 0.4;
  }
  to {
      opacity: 1.0;
  }
}
.content-8 {
  & /deep/ {
    .luzhutable__content__item {
      &:nth-child(1) {
        .textbox__item {
          &:nth-last-child(1) {
            .textbox__item__text{
              font-size: 14PX;
              height: 60px;
              animation: fade 600ms infinite;
            }
          }
        }
      }
    }
  }
}
</style>
